// src/components/TradingAutomatizadoModal.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { httpsCallable } from "firebase/functions";
import { functions } from '../firebaseConfig';
import '../assets/styles/modal.css';

const TradingAutomatizadoModal = ({ isOpen, onClose, userData }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);


  // Estados para saldo Binance
  const [balanceData, setBalanceData] = useState(null);
  const [loadingBalance, setLoadingBalance] = useState(false);

  useEffect(() => {
    if (isOpen) {
      fetchBinanceBalance();
    } else {
      // Reset al cerrar
      setBalanceData(null);
      setError(null);
    }
  }, [isOpen]);

  const fetchBinanceBalance = async () => {
    setLoadingBalance(true);
    setBalanceData(null);

    // No reseteamos error general aquí para no borrar errores de otras acciones, 
    // pero si para el fetch.

    try {
      const fn = httpsCallable(functions, 'obtenerSaldoBinance');
      const result = await fn();
      const data = result.data;

      if (data.success) {
        setBalanceData(data);
      } else {
        // Si falla (ej: NO_KEYS), lo mostramos como error o manejamos silenciosamente
        console.warn("Binance Fetch:", data.message);
        if (data.code === 'NO_KEYS') {
          // Opcional: Podríamos mostrar un mensaje específico o dejar que el UI muestre "No configurado"
          setError("API Key no configurada. Sube tu QR.");
        } else {
          setError(data.message || "Error al obtener saldo.");
        }
      }
    } catch (err) {
      console.error("Error calling obtenerSaldoBinance:", err);
      // No mostramos error en pantalla si es interno para no asustar, o sí?
      // setError("Error de conexión al verificar saldo.");
    } finally {
      setLoadingBalance(false);
    }
  };

  // ---  Redirecciona para abrir el modal de QR ---
  const handleCompletarPerfil = () => {
    // 1. Navegamos a la página de perfil Y le pasamos el nuevo parámetro 'openQR'
    navigate('/perfil?openQR=true');
  };
  // ------------------------------------------------------------------

  const handleSolicitarInforme = async () => {
    setIsLoading(true);
    setError(null);
    if (!userData?.email) {
      setError("No se ha detectado un email en tu perfil.");
      setIsLoading(false);
      return;
    }
    try {
      const response = await fetch('/api/generar-informe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: userData.email }),
      });
      const data = await response.json();
      if (data.success) {
        alert(`¡Solicitud enviada! El informe se enviará a ${userData.email} en breves momentos.`);
        onClose();
      } else {
        if (data.message === "Cliente no encontrado") {
          throw new Error("Usted no es cliente activo");
        }
        throw new Error(data.message || "La API retornó un error.");
      }
    } catch (err) {
      console.error("Error al solicitar informe:", err);
      if (err.message === "Usted no es cliente activo") {
        setError("Usted no es cliente activo");
      } else {
        setError("No se pudo conectar con el servidor de informes. Intenta más tarde.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>&times;</button>

        <h2>Activar Trading Automatizado</h2>
        <p>
          Para activar tu servicio de Trading Automatizado, sube el Código QR de tu API Key
          o solicita un informe de historial de trading.
        </p>

        {/* --- BLOQUE DE SALDO BINANCE --- */}
        <div style={{ margin: '20px 0', padding: '15px', background: '#f8f9fa', borderRadius: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
          <h4 style={{ margin: '0 0 10px 0', color: '#1a1a2e' }}>Saldo en Binance Futures</h4>
          {loadingBalance ? (
            <p>Cargando saldo...</p>
          ) : balanceData ? (
            <div>
              <span style={{ fontSize: '2rem', fontWeight: 'bold', color: '#28a745' }}>
                {balanceData.balance.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
              </span>
              <span style={{ fontSize: '0.8rem', color: '#666', display: 'block' }}>{balanceData.currency} Margin Balance</span>
            </div>
          ) : (
            <p style={{ color: '#777', fontStyle: 'italic' }}>
              {error && error.includes('Claves') ? 'API Key no configurada' : 'No disponible'}
            </p>
          )}
        </div>
        {/* ------------------------------- */}

        {error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}

        <div className="modal-actions" style={{ flexDirection: 'column', gap: '15px', alignItems: 'stretch' }}>
          <button
            className="btn btn-primary"
            onClick={handleCompletarPerfil}
            disabled={isLoading}
          >
            Subir Código QR
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSolicitarInforme}
            disabled={isLoading}
          >
            {isLoading ? 'Procesando...' : 'Solicitar Informe Historial'}
          </button>
        </div>
      </div>
    </div>

  );
};

export default TradingAutomatizadoModal;